
// 存储空间名称
const bucketName = 'jmc'

// 存储空间域名URL地址
const bucketUrl = 'https://img.yfisher.com'

// 令牌公钥
const tokenPublicKey = 'TOKEN_8621ff5f-342c-444b-8153-7e01ebffe881'

// 令牌私钥
const tokenPrivateKey = '5c938d99-3178-4f47-92ef-8fde6c7c04e4'

// 签名服务器地址
const tokenServerUrl = true

// 签名服务器地址
// const getSignature = api.getUfileSignature

export const UCloudParams = {
  bucketName,
  bucketUrl,
  tokenPublicKey,
  tokenPrivateKey,
  tokenServerUrl
}
